import { Injectable } from '@angular/core';
import { TableColumnDef } from '../table';

@Injectable({
    providedIn: 'root',
})
export class TableStateService {
    save(state: TableState): void {
        // Filter out null, undefined, or any falsy values from displayedColumns
        const filteredColumns = state.displayedColumns.filter(column => column != null);

        // Create a new state object with filtered columns
        const filteredState: TableState = {
            ...state,
            displayedColumns: filteredColumns,
        };

        // Save the filtered state to localStorage
        localStorage.setItem(state.name, JSON.stringify(filteredState));
    }

    getState(tableName: string): TableState | null {
        const state = localStorage.getItem(tableName);
        return state ? JSON.parse(state) : null;
    }
}

export interface TableState {
    name: string;
    displayedColumns: TableColumnDef[];
    formState: any;
}
